<style>
#dictionariesModal .v-messages {
  display: none;
}
#dictionariesModal .v--modal-box.v--modal {
  min-height: 280px !important;
  min-width: 450px !important;
}
#dictionariesModal .v-select__selections,
.v-list__tile__title {
  font-size: 12px;
}
.list__dict {
  height: calc(100% - 50px) !important;
}
</style>

<template>
  <div class="wrapper">
    <Modal
      modalName="dictionariesModal"
      title="SŁOWNIKI"
      @opened="getDicts"
      @removeDict="removeDict"
      @closed="closed"
      :buttons="['deleteDict', 'editDict', 'addDict']"
      class="font--primary"
    >
      <v-layout
        wrap
        align-center
      >
        <v-flex
          xs12
          d-flex
          class="modalSelect__layout"
          id="modalSelect__content"
        >
          <v-select
            :items="dicts"
            item-text="description"
            v-on:input="showDict"
            placeholder="Wybierz słownik ogólny"
            attach="#modalSelect__content"
            v-model="selected"
            height="16"
          ></v-select>
        </v-flex>
      </v-layout>
      <div class="list__container list__dict">
        <ul id="values__list">
          <li
            class="list__container--el"
            v-for="item in chosenDict[0]"
          >{{ item }}</li>
        </ul>
        <br>
        <!-- <div style="width:100%; display: flex; justify-content: space-between; padding-left: 15px; padding-right:15px;">
          <p v-for="(item, key) in chosenDictAttr">{{keyTran(key)}}: {{item}}</p>
        </div> -->
      </div>
    </Modal>
    <AddDictionary @updateDicts="getDicts"></AddDictionary>
    <EditDictionary @updateDicts="getDicts"></EditDictionary>
  </div>
</template>

<script>
import Modal from "../../../../shared/Modal";
import AddDictionary from "./AddDictionary";
import EditDictionary from "./EditDictionary";

export default {
  components: {
    Modal,
    AddDictionary,
    EditDictionary
  },
  data: () => ({
    dicts: [],
    chosenDict: [],
    chosenDictAttr: {},
    selected: null,
    username: undefined
  }),
  methods: {
    getLoadedDicts() {
      for(let el of this.$store.getters.getDicts) {
        if (el.description != null) this.dicts.push(el);
      }
      this.$root.$emit("showSnackbar", "success", "Załadowano słowniki");
      this.$nextTick(() => {
        this.selected = null;
      });
    },
    getDicts() {
      this.dicts = [];
      this.chosenDict = [];
      this.chosenDictAttr = {};

      if(this.username == 'aquagis') {
        document
          .querySelector("#btn__modal--edit")
          .classList.add("v-btn--disabled");
        document
          .querySelector("#btn__modal--remove")
          .classList.add("v-btn--disabled");
      }

      this.$store.dispatch("getDicts").then(r => {
        if(!r) {
          this.$root.$emit("showSnackbar", "red", "Brak dostępnych słowników");
        } else {
          this.getLoadedDicts();
        }
      });
    },
    showDict(value) {
      this.chosenDict = [];
      this.chosenDictAttr = {};
      for(let i of this.dicts) {
        if(i.description == value) {
          this.chosenDict.push(i.values);
          this.chosenDictAttr = i.references[0];
          this.$store.commit("setCurrentEditedDict", i);
          break;
        }
      }
      if(this.username == 'aquagis') {
        document
          .querySelector("#btn__modal--edit")
          .classList.remove("v-btn--disabled");
        document
          .querySelector("#btn__modal--remove")
          .classList.remove("v-btn--disabled");
      }
    },
    removeDict(dictId) {
      this.$store.dispatch("removeDict", dictId).then(r => {
        if(r) {
          this.$root.$emit(
            "showSnackbar",
            "green",
            "Poprawnie usunięto słownik"
          );
          this.chosenDict = [];
          this.getDicts();
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Wystąpił błąd podczas usuwania słownika"
          );
        }
      });
    },
    keyTran(key) {
      if(key == "column") return "Kolumna";
      else if(key == "schema") return "Schemat";
      else if(key == "table") return "Tabela";
    },
    closed() {
      this.chosenDict = [];
      this.chosenDictAttr = {};
    }
  },
  mounted() {
    this.username = localStorage.username;
  }
};
</script>


// WEBPACK FOOTER //
// src/components/viewer/settings/modals/dictionaries/Dictionaries.vue